// Documento: Primer flujo
// Categoría: Comienzo
// Última actualización: 2024-12-28

const document = {
  "id": "primer-flujo",
  "title": "Primer flujo",
  "category": "Comienzo",
  "description": "Aprende a crear tu primer flujo en Runamatic, desde la configuración básica hasta la publicación y pruebas.",
  "explanations": [
    {
      "title": "¿Qué es un flujo?",
      "content": "Un flujo es simplemente un orden de eventos que su automatización realizará. Usted puede disponer cualquier orden y cualquier tipo de evento de los que tenemos disponibles en Runamatic. Estos pueden mezclar botones, pedir información a los usuarios, interactuar con otras aplicaciones, inteligencia artificial y mucho más."
    },
    {
      "title": "Configuraciones importantes",
      "content": "Debe tener en cuenta que si este flujo no está configurado como respuesta por defecto en Ajustes > General > Respuesta por defecto, una vez completado el flujo no volverá a iniciar. Algo similar para con la integración de las respuestas automáticas en Ajustes > Integraciones > OpenAI > Respuestas automáticas, si las respuestas automáticas están prendidas, estas serán el mecanismo de respuestas por default de su chatbot."
    }
  ],
  "steps": [
    {
      "title": "Acceder a la creación de flujos",
      "content": "Para armar su primer flujo acceda a Flujos > Añadir.",
      "images": [
        "https://drive.google.com/thumbnail?id=1gOt2G-JMeGAEdXvjLlmnHxyHc4UvMSnz&sz=w1000"
      ]
    },
    {
      "title": "Configurar el nombre del flujo",
      "content": "Póngale nombre al flujo.",
      "images": [
        "https://drive.google.com/thumbnail?id=1LvCmUzPpteWl5eRkNJRmitu2RZRCkiwc&sz=w1000"
      ]
    },
    {
      "title": "Configurar el bloque \"Send Message\"",
      "content": "En el bloque \"Send Message\" puede configurar que tipo de mensaje va a enviar, estos varían dependiendo los canales. Si usted no tiene conectados todos los canales, solo se mostrarán aquellos que estén conectados. (Instagram, Facebook, WhatsApp, etc).",
      "images": [
        "https://drive.google.com/thumbnail?id=1jKryXQW4NrGXoZl4fkkApSsrEBRUvEKW&sz=w1000"
      ]
    },
    {
      "title": "Publicar el flujo",
      "content": "Una vez que complete su flujo debe publicarlo para que sea accesible fuera de la plataforma. A la derecha del botón de publicar está un ícono con 3 puntos, al clickearlo se mostrarán más opciones del control de flujos.",
      "images": [
        "https://drive.google.com/thumbnail?id=1lEBxxXgHeHaz9ejcI7FQdKdHuFVaJJpy&sz=w1000"
      ]
    },
    {
      "title": "Probar el flujo",
      "content": "Para poder probar su flujo, una de las maneras es darle click al ícono del ojo, ubicado abajo al centro. Al acceder a la vista previa podrá interactuar con el flujo que acaba de crear.",
      "images": [
        "https://drive.google.com/thumbnail?id=1fk8qX-LLIQow8UH7HzSvxHjoCvaDXTMu&sz=w1000"
      ]
    }
  ],
  "tags": [
    "flujo",
    "principiantes",
    "automatización",
    "configuración"
  ],
  "lastUpdated": "2024-12-28",
  "difficulty": "básico"
};

export default document;
